import React, { ReactElement } from 'react'
import { oneOf } from 'prop-types'
import { CallToAction, Heading } from '@scentregroup/ui'
import ExternalLink from '../external-link'
import { LinkSectionPropsType, LinkSection } from './link-section'
import style from './index.scss'

interface PropsType {
  country: string
}

const LOGIN_AU = 'https://account.westfield.com.au/login'
const SUBSCRIBE_AU = 'https://account.westfield.com.au/register'
const SUBSCRIBE_NZ = 'https://www.westfield.co.nz/westfield-plus'
const westfieldPlusSection: LinkSectionPropsType = {
  heading: { text: 'Westfield Plus', url: '/westfield-plus' },
  links: [
    { text: 'Login', url: LOGIN_AU },
    { text: 'Join', url: SUBSCRIBE_AU },
  ],
}

export const WestfieldPlusContainer = ({
  country,
}: PropsType): ReactElement => (
  <div className={style.westfieldPlusContainer}>
    {country === 'Australia' && (
      <LinkSection
        heading={westfieldPlusSection.heading}
        links={westfieldPlusSection.links}
      />
    )}
    <div className={style.joinSection}>
      <Heading type="small" className={style.joinTitle}>
        Get more every day with Westfield Plus
      </Heading>
      <CallToAction
        inverted
        fullWidth
        element={ExternalLink}
        className={style.footerButton}
        url={country === 'New Zealand' ? SUBSCRIBE_NZ : SUBSCRIBE_AU}
        data-test-id="subscribe-button"
      >
        Join
      </CallToAction>
    </div>
  </div>
)

WestfieldPlusContainer.propTypes = {
  country: oneOf(['Australia', 'New Zealand']).isRequired,
}
